import { Button, makeStyles, Theme } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { observer } from 'mobx-react';
import * as React from 'react';
import { mg } from '../../mg/mg';
import { toasterSvc } from '../../services/ToasterSvc';
import { useOmnistore } from '../../stores/Omnistore';
import { _IEditProps } from './_IEditProps';

const useStyles = makeStyles((theme: Theme) => ({
	_ImageLinkEdit: {
		display: 'flex',
		flexDirection: 'column',
	},
	label: {
	},
	image: {
		flex: 1,
		minHeight: 100,
		maxHeight: 100,
		height: 100,
		backgroundSize: 'contain',
		backgroundRepeat: 'no-repeat',
	},
	error: {
		color: 'red',
	},
	hidden: {
		display: 'none',
	},
}));

export const _ImageLinkEdit = observer(function _ImageLinkEdit(props: _IEditProps) {
	const classes = useStyles();
	const ref = React.useRef<HTMLInputElement>(null);
	const communicator = useOmnistore().communicator;
	const {accessors, type, label, error, isRequired, isReadonly, className, variant, helperText, placeholder} = props;
	const value = accessors.getter() as string;
	const omnistore = useOmnistore();
	const src = (value.match(/^\/i\//) ? omnistore.authStore.baseUrl : '') + value;
	const style: CSSProperties = {backgroundImage: !src ? undefined : `url(${src})`};

	function selectFile() {
		ref.current?.click();
	}
	function uploadImage(file: File|undefined) {
		if (!file) return;
		toasterSvc.info('uploadImageStarted');
		communicator.doUpload('UploadImage', {name: file.name}, file)
			.then(toasterSvc.handleResponse('uploadImageDone'))
			.then(r => r.outputObject && accessors.setter('' + r.outputObject));
	}

	return <div className={classes._ImageLinkEdit}>
		<input
			ref={ref}
			accept="image/*"
			className={classes.hidden}
			type="file"
			onChange={e => uploadImage(e.currentTarget.files?.[0] || undefined)}
		/>
		<Button className={mg.clsn(classes.image, error && classes.error)} style={style} onClick={selectFile}>
			{label + (isRequired ? ' *' : '')}
		</Button>
	</div>;
});
